var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"u-success"},[_c('img',{attrs:{"src":_vm.extraItem.extras('rejectResult.src'),"alt":""}})]),(_vm.extras.rejectResult.text != 'hide')?_c('div',{staticClass:"t-success-new",style:({
      color:
        _vm.extras.successResult.text == 'custom'
          ? _vm.extras.successResult.fontColor
          : '',
      'font-size':
        _vm.platform != 'wap' && _vm.extras.successResult.text == 'custom'
          ? _vm.extras.successResult.fontSize + 'px'
          : '',
      'font-style':
        _vm.extras.successResult.text == 'custom'
          ? _vm.extras.successResult.fontTilt == 'on'
            ? 'italic'
            : 'normal'
          : '',
      'font-Weight':
        _vm.extras.successResult.text == 'custom'
          ? _vm.extras.successResult.fontWeight == 'on'
            ? 'bolder'
            : ''
          : '',
    })},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"rejectResult.content"))+" ")]):_vm._e(),(_vm.extras.rejectResult.text2 != 'hide')?_c('div',{staticClass:"t-success-desc-new",style:({
      color:
        _vm.extras.successResult.text2 == 'custom'
          ? _vm.extras.successResult.fontColor2
          : '',
      'font-size':
        _vm.platform != 'wap' && _vm.extras.successResult.text2 == 'custom'
          ? _vm.extras.successResult.fontSize2 + 'px'
          : '',
      'font-style':
        _vm.extras.successResult.text2 == 'custom'
          ? _vm.extras.successResult.fontTilt2 == 'on'
            ? 'italic'
            : 'normal'
          : '',
      'font-Weight':
        _vm.extras.successResult.text2 == 'custom'
          ? _vm.extras.successResult.fontWeight2 == 'on'
            ? 'bolder'
            : ''
          : '',
    })},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"rejectResult.content2"))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }